<section class="card">
  <button
    type="button"
    class="card-header"
    [attr.aria-expanded]="expanded()"
    (click)="toggle()"
    dataSelector="cxp-crl-uncategorized-card-toggle"
  >
    <aiwyn-icon
      class="card-chevron"
      [name]="expanded() ? 'chevron-up' : 'chevron-down'"
      [height]="16"
      [width]="16"
    />
    <span class="card-heading">
      <span class="card-title">{{ headerText() }}</span>
      <span class="card-subtitle">We'll review these files and organize them soon</span>
    </span>
  </button>

  @if (expanded()) {
    <ul class="card-list">
      @for (file of vm().files; track file.id) {
        <li class="card-row">
          <awn-file-item-icon [fileName]="file.name" class="card-row-icon" />
          <span class="card-row-name" tooltipOverflow>{{ file.name }}</span>
          <span class="card-row-size">{{ (file.size ?? 0) | fileSize: 1 }}</span>
          <button
            andButton
            color="ghost"
            size="small"
            class="card-row-remove"
            [attr.aria-label]="'Remove ' + file.name"
            (click)="onRemove(file)"
            dataSelector="cxp-crl-uncategorized-card-remove"
          >
            <aiwyn-icon name="x" [height]="16" [width]="16" />
          </button>
        </li>
      }
    </ul>
  }
</section>
